import React from "react";
import LocaleSwitcher from "./ui/LocaleSwitcher";

const HeaderDescriptionsSM = ({ input }) => {
  const { descriptionLeft, descriptionRight } = input;

  const textToSpan = text => {
    const clean = text.replace(/(\r\n|\n|\r)/gm, " ");
    const parts = clean.split(" ");
    // console.log(parts);
    return parts.map((el, i) => (
      <span key={i} className='desc-span'>
        {el}
      </span>
    ));
  };
  return (
    <div className='descriptions-sm fSeg'>
      <div className='row between-xs h100'>
        <div className='col-xs-12 f2'>
          <div className='x xjc xac'>
            <LocaleSwitcher />
          </div>
        </div>
        <div className='col-xs-12'>
          <div className='ttu mb2'>{textToSpan(descriptionLeft)}</div>
        </div>
        <div className='col-xs-12'>
          <div className='ttu fSeg '>{textToSpan(descriptionRight)}</div>
        </div>
      </div>
    </div>
  );
};

export default HeaderDescriptionsSM;
